import OpenAI from 'openai';
import { generateSystemPrompt } from '../services/chatbot/prompts';

const validateApiKey = () => {
  const apiKey = import.meta.env.VITE_OPENAI_API_KEY;
  if (!apiKey) {
    console.error('OpenAI API key is missing. Chat functionality will be disabled.');
    return false;
  }
  return true;
};

export const openai = validateApiKey() ? new OpenAI({
  apiKey: import.meta.env.VITE_OPENAI_API_KEY,
  dangerouslyAllowBrowser: true
}) : null;

export const SYSTEM_PROMPT = generateSystemPrompt();

export const isOpenAIAvailable = () => !!openai;